export default __webpack_public_path__ + "static/media/renolog1.89d3fc1b.jpg";